import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/eye.svg";
var EyeSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  EyeSolid_default as default
};
